import { render, staticRenderFns } from "./top5.vue?vue&type=template&id=c0d4dd2e&scoped=true"
import script from "./top5.vue?vue&type=script&lang=js"
export * from "./top5.vue?vue&type=script&lang=js"
import style0 from "./top5.vue?vue&type=style&index=0&id=c0d4dd2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d4dd2e",
  null
  
)

export default component.exports